module.exports = __webpack_public_path__ + "static/media/9.e96d6281.jpg";